import { render, staticRenderFns } from "./Prefix.vue?vue&type=template&id=3ec102f7&scoped=true&lang=pug&"
import script from "./Prefix.vue?vue&type=script&lang=js&"
export * from "./Prefix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec102f7",
  null
  
)

export default component.exports